class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');
    // this.setMobileObstructionsDimmed(true);

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    // this.setMobileObstructionsDimmed(false);
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  // setMobileObstructionsDimmed(shouldDim) {
  //   document.body.classList.toggle('dbt-cart-notification-open', shouldDim);

  //   document.querySelectorAll('.dbt-cart-obstruction-dimmed').forEach((element) => {
  //     element.classList.remove('dbt-cart-obstruction-dimmed');
  //   });

  //   if (!shouldDim || !window.matchMedia('(max-width: 749px)').matches) return;

  //   const dimMatchingWidgets = () => {
  //     const textNeedles = ['get an extra 5% off', 'live chat'];
  //     const candidates = document.querySelectorAll('button, a, div, aside, iframe');

  //     candidates.forEach((candidate) => {
  //       if (candidate.closest('cart-notification')) return;

  //       const title = `${candidate.getAttribute('title') || ''} ${candidate.getAttribute('aria-label') || ''}`.toLowerCase();
  //       const text = candidate.tagName === 'IFRAME' ? title : (candidate.textContent || '').trim().toLowerCase();
  //       if (!textNeedles.some((needle) => text.includes(needle))) return;

  //       let fixedElement = candidate;
  //       while (fixedElement && fixedElement !== document.body) {
  //         const position = getComputedStyle(fixedElement).position;
  //         if (position === 'fixed' || position === 'sticky') break;
  //         fixedElement = fixedElement.parentElement;
  //       }

  //       (fixedElement && fixedElement !== document.body ? fixedElement : candidate)
  //         .classList.add('dbt-cart-obstruction-dimmed');
  //     });
  //   };

  //   dimMatchingWidgets();
  //   window.setTimeout(dimMatchingWidgets, 250);
  //   window.setTimeout(dimMatchingWidgets, 800);
  // }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;

    this.getSectionsToRender().forEach((section) => {
      const target = document.getElementById(section.id);
      const sectionHTML = parsedState.sections?.[section.id];

      // DBT: Some third-party add-to-cart flows may omit an optional section.
      // Skip it safely instead of preventing the notification from opening.
      if (!target || !sectionHTML) return;

      const replacementHTML = this.getSectionInnerHTML(sectionHTML, section.selector);
      if (replacementHTML === null) return;

      target.innerHTML = replacementHTML;
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-summary',
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const selectedElement = parsedHTML.querySelector(selector);
    return selectedElement ? selectedElement.innerHTML : null;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
